import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import VueExcelEditor from "vue3-excel-editor";
//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/prismjs";

import globalMixin from "./globalMixin.js";

import VueGoogleMaps from "@fawmi/vue-google-maps";

import PerfectScrollbar from "vue3-perfect-scrollbar";

// import dayjs from "dayjs";
// import "dayjs/locale/th";
// import localeData from "dayjs/plugin/localeData";

const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.mixin(globalMixin);
app.use(VueExcelEditor);
app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBYy6wOtVviFQiE7E0kWjML3x8Jvu3TUFQ",
    language: "TH",
  },
});
app.use(PerfectScrollbar);

// dayjs.locale("th");

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
